<script setup lang="ts">
import { computed } from 'vue';
import { ValueFormatConfig, valueFormat } from '@/helpers/valueFormat';
import { PropType } from 'vue';
import useCurrentCurrency from '@/helpers/currency/useCurrentCurrency';
import { useAppStore } from '@/store/app';

const props = defineProps({
  value: {
    type: [Number, null] as PropType<number | null>,
    required: false,
  },
  config: {
    type: Object as PropType<Partial<ValueFormatConfig>>,
    required: false,
  },
});

const currentCurrency = useCurrentCurrency();

const config = computed(() => {
  return {
    ...props.config,
    currency: currentCurrency.currency.value,
    currencyRate: currentCurrency.rate.value,
  };
});

const hideValues = useAppStore();

const computedValue = computed(() => {
  if (hideValues.hideValues) {
    return '*****';
  }
  return valueFormat(props.value ?? undefined, config.value);
});
</script>

<template>
  <span>
    {{ computedValue }}
  </span>
</template>
